module.exports = __webpack_public_path__ + "static/media/2.4c1b43f5.jpg";